import { gql } from '@apollo/client'

export const MUTATION_REMOVE_TAGS_FOR_EMPLOYEES = gql`
  mutation mutationRemoveTagsForEmployees(
    $input: RemoveTagsForEmployeesInput!
  ) {
    removeTagsForEmployees(input: $input)
  }
`
